<section class="cases-section">
    <div class="container">
        <div class="section-header">
            <h2 class="section-title">Mis expedientes</h2>
            <a class="section-link" *ngIf="!loading && items.length > 0" (click)="irA('/expedientes')">Ver todos los expedientes</a>
        </div>
        <div class="cases-grid" *ngIf="loading">
            <div class="expediente-card expediente-card--skeleton" *ngFor="let s of skeletonSlots">
                <div class="expediente-card-head">
                    <span class="skeleton skeleton-icon"></span>
                    <span class="skeleton skeleton-tag"></span>
                </div>
                <span class="skeleton skeleton-line skeleton-line--title"></span>
                <div class="expediente-poliza">
                    <span class="skeleton skeleton-line skeleton-line--xs"></span>
                    <span class="skeleton skeleton-line skeleton-line--sm"></span>
                </div>
                <div class="expediente-meta">
                    <span class="skeleton skeleton-line skeleton-line--md"></span>
                    <span class="skeleton skeleton-line skeleton-line--md"></span>
                </div>
                <div class="expediente-actions">
                    <span class="skeleton skeleton-btn"></span>
                    <span class="skeleton skeleton-btn"></span>
                </div>
            </div>
        </div>
        <div class="expediente-empty" *ngIf="!loading && items.length === 0">
            Aún no hay ningún expediente
        </div>
        <div class="cases-grid" *ngIf="!loading && items.length > 0">
            <div class="expediente-card" *ngFor="let expediente of items">
                <div class="expediente-card-head">
                    <span class="expediente-icon" aria-hidden="true">
                        <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M18 4H8a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V12l-8-8z"/>
                            <path d="M18 4v6a2 2 0 0 0 2 2h6"/>
                            <line x1="11" y1="18" x2="21" y2="18"/>
                            <line x1="11" y1="22" x2="17" y2="22"/>
                        </svg>
                    </span>
                    <span class="expediente-tag" [ngClass]="tagClass(expediente.estado)">{{ expediente.estado }}</span>
                </div>
                <h3 class="expediente-titulo">{{ expediente.titulo }}</h3>
                <div class="expediente-poliza">
                    <span class="poliza-label">Nº de póliza</span>
                    <span class="poliza-value">{{ expediente.polizaNumero }}</span>
                </div>
                <div class="expediente-meta">
                    <p><span>Expediente </span><strong>{{ expediente.expedienteNumero }}</strong></p>
                    <p><span>Fecha de ocurrencia </span><strong>{{ expediente.fechaOcurrencia }}</strong></p>
                </div>
                <!-- Solo el asegurado del expediente puede abrir el detalle y escribir al
                     tramitador; al tomador que no es el asegurado se le muestra la tarjeta
                     informativa pero sin acciones. -->
                <div class="expediente-actions" *ngIf="puedeOperar(expediente)">
                    <button class="btn-detail" (click)="irDetalle(expediente)">Ver detalle</button>
                    <button class="btn-tramitador" (click)="irTramitador(expediente)">Contacta tramitador/a</button>
                </div>
            </div>
        </div>
    </div>
</section>
